<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on: menu }">
        <v-tooltip bottom>
          <template v-if="!loading" v-slot:activator="{ on: tooltip }">
            <printer-icon  v-on="{ ...tooltip, ...menu }" class="custom-class feather-icon" :class="[$vuetify.breakpoint.xlOnly ? 'feather-icon-xl' : 'feather-icon-lg-down']"></printer-icon>
          </template>
          <template v-else v-slot:activator="{ on: tooltip }">
            <i v-on="{ ...tooltip, ...menu }" class="fas fa-spinner fa-spin"></i>
          </template>
          <span :class="[$vuetify.breakpoint.xlOnly ? 'tooltip-message-xl' : 'tooltip-message-lg-down']">{{$t('print_files.export')}}</span>
        </v-tooltip>
      </template>
      <v-list>
        <v-list-item @click="exportShipmentsListPdf">
          <v-list-item-title>PDF</v-list-item-title>
        </v-list-item>
        <v-list-item @click="exportShipmentsListCsv">
          <v-list-item-title>CSV</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import Roboto from '@/assets/fonts/Roboto-Regular-normal.js'
import RobotoBold from '@/assets/fonts/Roboto-Bold-bold.js'
import * as Sentry from '@sentry/browser'

export default {
  name: 'DaysMetricMetadata',
  components: {},
  props: {
      day: Object
  },
  data () {
    return {
      head: [],
      body: [],
      rows: [],
      departure: null,
      arrival: null,
      company: null,
      weight: null,
      volume: null,
      route: [],
      status: null,
      type: null,
      loading: false
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      getShipmentsForExportPerDay: ['shipmentsGroupByDay/getShipmentsForExportPerDay'],
    }),
    ...mapGetters('cognito', ['userAttributes']),
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar'
    }),
    sortShipmentData (data) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].labels.length; j++) {
          data.sort((a, b) => {
            // sorts by labels alphabetically
            // does not sort by day because all shipments are in same day

            if (a.labels[j] > b.labels[j]) return 1
            if (a.labels[j] < b.labels[j]) return -1
          })
        }
      }
    },
    exportShipmentsListPdf () {
      this.loading = true
      let Pdf = jsPDF
      let doc = new Pdf('landscape')
      // font to Roboto so we won't have problems with encoding
      doc.addFileToVFS('Roboto-Regular.ttf', Roboto)
      doc.addFileToVFS('Roboto-Bold.ttf', RobotoBold)
      doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')
      doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold')
      doc.setFont('Roboto')
      doc.setFontSize(14)
      this.head = []
      this.body = []
      this.head.push(
        [
          { content: this.$i18n.t('print_files.departure') },
          { content: this.$i18n.t('print_files.arrival') },
          { content: this.$i18n.t('print_files.shipment_type') },
          { content: this.$i18n.t('print_files.company') },
          { content: this.$i18n.t('print_files.weight') + ' [KG]' },
          { content: this.$i18n.t('print_files.volume') + ' [CBM]' },
          { content: this.$i18n.t('print_files.route') },
          { content: this.$i18n.t('print_files.status') }
        ]
      )
      if (this.day.shipments.length > 0) {
        this.sortShipmentData(this.day.shipments)
         try {
           for (let i = 0; i < this.day.shipments.length; i++) {
            this.shipmentData(this.day.shipments, i)
            this.body.push([this.departure, this.arrival, this.type, this.company, this.weight, this.volume, this.route.join(', '), this.status])
            } 
        } catch (err) {
          console.log(err)
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      }

      if (this.body.length > 0) {
        doc.setFontStyle('bold')
        doc.text(this.$i18n.t('print_files.shipments_list').toUpperCase(), 130, 10)

        doc.setFontStyle('normal')
        doc.autoTable({
          head: this.head,
          body: this.body,
          styles: { fontSize: 10, textColor: [33, 33, 33], font: 'Roboto' },
          theme: 'grid',
          rowPageBreak: 'avoid',
          headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 },
          columnStyles: { 0: { cellWidth: 35 }, 1: { cellWidth: 35 }, 2 : { cellWidth: 35 },  4: { halign: 'right', cellWidth: 28 }, 5: { halign: 'right', cellWidth: 28 } },
          startY: 20
        })

        let pageCount = doc.internal.getNumberOfPages()
        let dateObj = new Date()
        let day = dateObj.getDate()
        // months in js are indexed from 0
        let month = dateObj.getMonth() + 1
        let year = dateObj.getFullYear()
        let hour = dateObj.getHours()
        // adds 0 in front of minutes when needed
        let minute = String(dateObj.getMinutes()).padStart(2, '0')
        let newDate = day + '/' + month + '/' + year
        let newTime = hour + ':' + minute
        for (let i = 0; i < pageCount; i++) {
          doc.setFontSize(14)
          doc.setPage(i)
          doc.text(262, 10, this.$i18n.t('print_files.pages') + ': ' + doc.internal.getCurrentPageInfo().pageNumber + '/' + pageCount)
          doc.setFontSize(9)
          doc.text(14, 203, `${this.$i18n.t('print_files.printed')} ${newDate} ${this.$i18n.t('print_files.at')} ${newTime} ${this.$i18n.t('print_files.by')} ${this.userAttributes.email}`)
          doc.text(244, 203, this.$i18n.t('print_files.generated'))
        }
        try {
          doc.save(`${this.$i18n.t('print_files.shipment_list_file_name')}.pdf`)
        } catch (err) {
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          Sentry.captureException(err)
          this.loading = false
        }
        this.loading = false
      }
    },
    exportShipmentsListCsv () {
      this.loading = true
      this.rows = []
      let csvContent = 'data:text/csv;charset=utf-8,'
      this.rows.push([this.$i18n.t('print_files.departure'), this.$i18n.t('print_files.arrival'), this.$i18n.t('print_files.shipment_type'), this.$i18n.t('print_files.company'), this.$i18n.t('print_files.weight') + ' (KG)', this.$i18n.t('print_files.volume') + ' (CBM)', this.$i18n.t('print_files.route'), this.$i18n.t('print_files.status')])

      if (this.day.shipments.length > 0) {
        this.sortShipmentData(this.day.shipments)
         try {
           for (let i = 0; i < this.day.shipments.length; i++) {
            this.shipmentData(this.day.shipments, i)
            this.rows.push([this.departure, this.arrival, this.type, this.company, this.weight, this.volume, this.route.join(', '), this.status])
            } 
        } catch (err) {
          Sentry.captureException(err)
          this.showSnackbar({ message: this.$t('snackbars.error'), color: 'error' })
          this.loading = false
        }
      }

      if (this.rows.length > 1) {
        this.rows.forEach(function (rowArray) {
          let row = rowArray.join(';').replace(',', '-')
          csvContent += row + '\r\n'
        })
        try {
          let encodedUri = encodeURI(csvContent)
          let link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', `${this.$i18n.t('print_files.shipment_list_file_name')}.csv`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } catch (err) {
          Sentry.captureException(err)
          this.loading = false
        }
      }
      this.loading = false
    },
    shipmentData (shipments, i) {
      this.departure = null
      this.arrival = null
      this.company = null
      this.weight = null
      this.volume = null
      this.route = []
      this.status = null
      this.type = null
      
      if (shipments[i].pickupLocal) {
        this.departure = this.$options.filters.dateToReadableFullMoment(shipments[i].pickupLocal.from, this.$i18n.locale)
      } else {
            this.departure = 'N/A'
        }
          
        if (shipments[i].deliveryLocal) {
          this.arrival = this.$options.filters.dateToReadableFullMoment(shipments[i].deliveryLocal.from, this.$i18n.locale)
        } else {
            this.arrival = 'N/A'
        }

        if (shipments[i].type === 'OnePL' && shipments[i].vehicle && shipments[i].vehicle.organization.name !== '' && shipments[i].vehicle.organization.name !== null) {
            this.company = shipments[i].vehicle.organization.name
        } else if (shipments[i].type === 'TwoPL' && shipments[i].vehicleClass && shipments[i].vehicleClass.organization.name !== '' && shipments[i].vehicleClass.organization.name !== null) {
          this.company = shipments[i].vehicleClass.organization.name
        } else if (shipments[i].type === 'ThreePL' && shipments[i].quoting && shipments[i].quoting.selectedQuote.organization.name !== '' && shipments[i].quoting.selectedQuote.organization.name !== null) {
          this.company = shipments[i].quoting.selectedQuote.organization.name
        } else {
          this.company = 'N/A'
        }

        if (shipments[i].drops && shipments[i].drops.weight !== null && shipments[i].drops.weight !== '') {
          this.weight = this.$options.filters.roundValueWeight(shipments[i].drops.weight, 0)
        } else {
          this.weight = 'N/A'
        }
        
        if (shipments[i].drops && shipments[i].drops.volume !== null && shipments[i].drops.volume !== '') {
          this.volume = this.$options.filters.roundValue(shipments[i].drops.volume, 1)
        } else {
          this.volume = 'N/A'
        }
        
        if (shipments[i].labels != null && shipments[i].labels.length > 0) {
          for (let j = 0; j < shipments[i].labels.length; j++) {
            this.route.push(shipments[i].labels[j])
          }
        } else {
          this.route.push('N/A')
        }
        this.status = shipments[i].status
        this.type = shipments[i].type
    }
  }
}
</script>

<style lang="scss" scoped>
  .feather-icon {
    cursor: pointer;
  }
  .feather-icon-xl {
    width: 20px;
    height: 20px;
  }
  .feather-icon-lg-down {
    width: 15px;
    height: 15px;
    margin-bottom: 1px;
  }
  .tooltip-message-xl {
    font-size: 14px;
  }
  .tooltip-message-lg-down {
    font-size: 12px;
  }
</style>
